import React, { useRef } from "react";
import { useRouter } from "next/router";
import Link from "next/link";

//components
import AboutUs from "../components/AboutUs";

//mui
import VerifiedIcon from "@mui/icons-material/Verified";

//slick slider
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

//hook
import useTranslation from "../hooks/useTranslation";

const RecrutementLayout = () => {
  const router = useRouter();
  const { t } = useTranslation();

  const sliderRef = useRef(null);

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
  };
  return (
    <>
      <div
        style={{
          background:
            "linear-gradient(62.75deg, #0E0E0E  22.4%, #464544 80.72%)",
        }}
        className="w-full h-auto lg:h-screen relative"
      >
        <div className="z-10 h-auto lg:h-full relative">
          <div className="max-w-[1366px] md:px-8 relative mx-auto h-full flex flex-col lg:flex-row">
            <div
              className={`order-2 relative m-auto lg:absolute z-20 -bottom-[3px] lg:-bottom-[4px] w-[30%] lg:w-[25%] ${
                router.locale === "ar" ? "lg:left-[10%]" : "lg:left-[70%]"
              }`}
            >
              <img
                src="/svg/recrutement.svg"
                alt="recrutement"
                className="w-full"
              />
            </div>
            <div className="order-1 w-full h-auto lg:h-full flex flex-col pt-[108px]">
              <div className="flex flex-col h-auto lg:h-full justify-center gap-16 lg:gap-20">
                <div className="flex flex-col justify-center text-white">
                  <div className="flex flex-col gap-9 items-center lg:items-start px-[40px] lg:w-[70%]">
                    <h1 className="uppercase text-[26px] lg:text-[43px] leading-[35px] lg:leading-[55px] font-bold text-center lg:text-left">
                      {t("Devenez une travailleuse chez nous")}
                    </h1>
                    <p className="text-base tracking-wider max-w-[564px] font-light text-center lg:text-left">
                      {t(
                        "travaillez selon des horaires flexibles et recevez un salaire compétitif, tout en offrant un service précieux à nos clients."
                      )}
                    </p>
                    {/* <Link href="/inscription"> */}
                    <button
                      onClick={() => router.push("/inscription")}
                      className="mt-[6px] rounded-lg duration-300 bg-secondary flex justify-center items-center ha:hover:bg-primary py-[12.5px] px-[65px] text-base font-semibold w-max"
                    >
                      {t("S’inscrire Gratuitement")}
                    </button>
                    {/* </Link> */}
                  </div>
                </div>
                <div className="bg-[#404040] text-white text-base rounded-[20px] lg:rounded-[30px] py-[20px] lg:py-[30px] px-[20px] lg:px-[60px] w-max mx-auto lg:mx-0">
                  <div className="flex flex-col gap-5">
                    <div className="flex items-center gap-5">
                      <img src="/svg/check.svg" alt="check" />
                      <span className="flex items-center gap-1 ltr">
                        {t("Travaillez où et quand vous voulez")}
                      </span>
                    </div>
                    <div className="flex items-center gap-5">
                      <img src="/svg/check.svg" alt="check" />
                      {t("Gagnez jusqu’à 40,000DZD par mois")}
                    </div>
                    <div className="flex items-center gap-5">
                      <img src="/svg/check.svg" alt="check" />
                      <span className="flex items-center gap-1">
                        {t("Améliorer vos revenus")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`absolute  top-0 bottom-0 ${
            router.locale === "ar" ? "left-0" : "right-0"
          }`}
        >
          <img src="/svg/bullets.svg" alt="bullets" />
        </div>
      </div>
      <div className="py-[64px] lg:py-[119px] md:px-8">
        <div className="flex justify-center items-center">
          <div className="flex flex-col items-center gap-16">
            <h1 className="uppercase text-[#505050] font-bold text-[22px] lg:text-[32px] leading-[31px] lg:leading-[44px] tracking-widest text-center">
              {t("Protocole de sécurité")}
            </h1>
            <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-28 justify-between text-base font-semibold tracking-[0.01em] text-black leading-5">
              <div className="flex flex-col items-center gap-5">
                <img
                  src="/svg/verification.svg"
                  alt="verification"
                  className="w-[60px] lg:w-[80px]"
                />
                <span className="text-center">
                  {t("Exécuter des vérifications")}
                </span>
              </div>
              <div className="flex flex-col items-center gap-5">
                <img
                  src="/svg/identity.svg"
                  alt="identity"
                  className="w-[60px] lg:w-[80px]"
                />
                <span>{t("Vérification d'identité")}</span>
              </div>
              <div className="flex flex-col items-center gap-5">
                <img
                  src="/svg/fraude.svg"
                  alt="fraude"
                  className="w-[60px] lg:w-[80px]"
                />
                <span>{t("Prévention de la fraude")}</span>
              </div>
              <div className="flex flex-col items-center gap-5">
                <img
                  src="/svg/security.svg"
                  alt="security"
                  className="w-[60px] lg:w-[80px]"
                />
                <span>{t("Examens de sécurité")}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="how py-[77px] md:px-8 bg-[#923FB30F]">
        <div className="max-w-[1366px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-20 lg:gap-48">
            <div className="flex flex-col gap-12 px-[40px]">
              <h1 className="uppercase sm:text-center lg:text-start text-[#505050] font-bold text-[22px] lg:text-[32px] leading-[31px] lg:leading-[44px] tracking-widest">
                {t("Comment ça marche ?")}
              </h1>
              <ul className="list-disc flex flex-col gap-4 text-lg text-[#727272] max-w-[558px]">
                <li className="flex items-center">
                  <VerifiedIcon
                    className={`${router.locale === "ar" ? "ml-3" : "mr-3"}`}
                  />
                  {t(
                    "Remplissez le formulaire avec vos informations correctes, cela prendra quelques minutes."
                  )}
                </li>
                <li className="flex items-center">
                  <VerifiedIcon
                    className={`${router.locale === "ar" ? "ml-3" : "mr-3"}`}
                  />
                  {t(
                    "choisissez une date pour faire un entretien avec notre équipe."
                  )}
                </li>
                <li className="flex items-center">
                  <VerifiedIcon
                    className={`${router.locale === "ar" ? "ml-3" : "mr-3"}`}
                  />
                  {t(
                    "Une fois accepté,accédez à votre tableau de bord pour choisir quand et où vous souhaitez travailler."
                  )}
                </li>
              </ul>
              <button
                onClick={() => router.push("/inscription")}
                className="mt-[20px] text-white rounded-lg duration-300 bg-secondary flex justify-center items-center ha:hover:bg-primary py-[12.5px] px-[65px] text-base font-semibold w-max"
              >
                {t("Devenir une travailleuse")}
              </button>
            </div>
            <div className="w-[250px] lg:w-[400px]">
              <Slider ref={sliderRef} {...settings}>
                <div key={1}>
                  <img src="/svg/mobile1.svg" />
                </div>
                <div key={2}>
                  <img src="/svg/mobile2.svg" />
                </div>
                <div key={3}>
                  <img src="/svg/mobile3.svg" />
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </div>
      <AboutUs />
    </>
  );
};

export default RecrutementLayout;
